import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

import Staff from '@model/staff'
import { onMounted } from 'vue'

export const useStaff = defineStore('staff', () => {
    const staffs = ref([])

    const getStaffs = computed(() => {
        return staffs.value || []
    })

    // Get Staff by ID
    const getStaffById = (staffId) => {
        return staffs.value.find(staff => staff.staff_id == staffId)
    }

    const isLoaded = ref(false)
    const model = (staff_id = null) => {
        return new Staff({ staff_id: staff_id })
    }
    const fetchStaffs = async (staff_id = null) => {
        // const response = await Ajax.get('admin_get_staffs', { staff_id: staff_id })
        const response = staff_id == null
            ? await Staff.init().all()
            : await model(staff_id).get()

        if (response && Array.isArray(response)) {
            response.forEach((staff) => {
                staff.meta.checkbox = false
            })
        }

        return response
    }

    const fetchData = async () => {
        staffs.value = await fetchStaffs()
        isLoaded.value = true
    }

    const fetchStaffByService = async (service_id = null) => {
        await fetchData()
        let filterStaffs = []

        staffs.value.forEach((staff) => {
            staff.services.forEach((service) => {
                if (service == service_id) {
                    filterStaffs.push(staff)
                }
            })
        })

        Log('STAFFS by service', filterStaffs)
        return filterStaffs
    }
    // Update Staff
    const updateStaff = async (staff) => {
        // return await Ajax.post('admin_update_staff', staff)
        const response = staff.staff_id
            ? await model(staff.staff_id).update(staff, staff.staff_id)
            : await model().create(staff)

        return response
    }

    // Delete Staff
    const deleteStaff = async (staff_id) => {
        // const choice = await Prompt.fire({
        //     title: 'Are you sure?',
        //     message: 'You won\'t be able to revert this!',
        //     ok: 'Delete',
        //     cancel: 'Dismiss',
        // })

        // if (!choice.ok) return false

        // // Ask again
        // const choice2 = await Prompt.fire({
        //     title: 'Are you really sure?',
        //     message: 'This action is irreversible!',
        //     ok: 'Delete',
        //     cancel: 'Dismiss',
        // })

        // if (!choice2.ok) return

        // const response = await Ajax.post('admin_delete_staff', { staff_id: staff_id })
        const response = await model(staff_id).delete()

        if (response.success) {
            staffs.value = staffs.value.filter(staff => staff.staff_id != staff_id)

            Toast.success(`${String($settings.labels.staff?.singular)} deleted successfully`)
        } else {
            Toast.error(response.message || 'Something went wrong')
        }

        return response
    }

    // search staff
    // const filterStaff = async (search) => {
    // console.log('staff search', search)
    // const response = await Ajax.get('admin_get_services',{search:'search'})
    // if (!response.success) return []

    // return response.data
    // }
    const bulkDelete = async (ids) => {
        if (!ids || !ids.length) return Toast.warning('Nothing to delete!')
        let response = await Staff.init().bulkDelete(ids)

        if (response.success) {
            Toast.success(`${ids.length > 1 ? ids.length : ''} ${String($settings.labels.staff?.singular)}${ids.length > 1 ? 's' : ''} deleted successfully`)
            await fetchData()
        } else {
            Toast.error(response.message)
        }
    }

    const bulkUpdate = async (ids, data) => {
        if (!ids || !ids.length) return Toast.warning('Nothing to update!')

        let response = await Staff.init().bulkUpdate(ids, data)

        if (response.success) {
            Toast.success(`${ids.length > 1 ? ids.length : ''} ${String($settings.labels.staff?.singular)}${ids.length > 1 ? 's' : ''} updated successfully`)
            await fetchData()
        }
        else {
            Toast.success(response.message)
        }
    }

    // const generateRandomText = (length) => {
    //     let result = ''
    //     let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    //     let charactersLength = characters.length

    //     for (let i = 0; i < length; i++) {
    //         result += characters.charAt(Math.floor(Math.random() * charactersLength))
    //     }

    //     return result
    // }
    // onMounted(async () => {
    //     for (let i = 0; i < 20; i++) {
    //         updateStaff({
    //             "meta": {
    //                 "color": "#F2C94C",
    //                 "first_name": generateRandomText(10),
    //                 "last_name": generateRandomText(10),
    //                 "title": generateRandomText(10),
    //                 "highlights": generateRandomText(10),
    //                 "email": `${generateRandomText(5)}@ad.com`,
    //                 "phone": Math.floor(Math.random() * 1000000000),
    //                 "bio": "asd",
    //                 "status": "publish"
    //             },
    //             "services": [
    //                 8,
    //                 7
    //             ],
    //             "status": "",
    //             "working_hours": {
    //                 "Monday": {
    //                     "enabled": false,
    //                     "hours": []
    //                 },
    //                 "Tuesday": {
    //                     "enabled": false,
    //                     "hours": []
    //                 },
    //                 "Wednesday": {
    //                     "enabled": false,
    //                     "hours": []
    //                 },
    //                 "Thursday": {
    //                     "enabled": false,
    //                     "hours": []
    //                 },
    //                 "Friday": {
    //                     "enabled": false,
    //                     "hours": []
    //                 },
    //                 "Saturday": {
    //                     "enabled": false,
    //                     "hours": []
    //                 },
    //                 "Sunday": {
    //                     "enabled": false,
    //                     "hours": []
    //                 }
    //             },
    //             "days_off": [],
    //             "display_name": generateRandomText(15)
    //         })
    //     }
    // })


    // export
    return {
        getStaffs,
        getStaffById,
        fetchStaffs,
        fetchData,
        isLoaded,
        updateStaff,
        // deleteStaff,
        fetchStaffByService,
        // filterStaff,
        bulkDelete,
        bulkUpdate
    }
})
